import { render } from "./consulting.vue?vue&type=template&id=01ab5a06"
import script from "./consulting.vue?vue&type=script&lang=js"
export * from "./consulting.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/utmtco-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__